import React from 'react'
import Select from 'react-select'

export default function WidgetProjectMultiSelector({ onChange, Projects, value }) {
    const handleMultiSelect = (options) => {
        if (options.length) {
            if (options[0].value === '*') {
                onChange([...Projects])
            }
            else {
                onChange(options)
            }
        }
        else {
            onChange([])
        }
    }

    const customStyles = {
        container: (provided) => ({
            ...provided,
            width: "100%",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    return (
        <Select
            isMulti
            options={[{ value: '*', label: 'Select All' }, ...Projects]}
            onChange={handleMultiSelect}
            value={value}
            styles={customStyles}
        />
    )
}
